import lax from "lax.js";
import WOW from "wowjs";
import smoothscroll from "smoothscroll-polyfill";

import "../home/index.css";
import "../home/components/navigation/navigation";
import "./index.css";
// import "./components/navigation/navigation";
import "./components/scene-1/scene-1";
import "./components/scene-2/scene-2";
import "./components/scene-3/scene-3";
import "./components/scene-4/scene-4";
import "./components/scene-5/scene-5";
import "./components/scene-6/scene-6";
import "./components/scene-7/scene-7";
import "./components/scene-8/scene-8";
import "./parallax/desktop";
import "./parallax/mobile";

import "../analytics";

lax.setup({
  breakpoints: { mobile: 0, desktop: 1025, large: 2000 },
});

const updateLax = () => {
  lax.update(window.scrollY);
  window.requestAnimationFrame(updateLax);
};

window.requestAnimationFrame(updateLax);

// kick off the polyfill!
smoothscroll.polyfill();

var wow = new WOW.WOW({
  boxClass: "wow", // default
  animateClass: "animated", // default
  offset: 0, // default
  mobile: true,
  live: false,
});
wow.init();
